import { IsBoolean, IsInt, IsOptional, IsString } from 'class-validator';

export class SendOtpDto {
  @IsInt()
  mobile!: number;

  @IsOptional()
  @IsString()
  refCode?: string;

  @IsBoolean()
  isViaExternalLink!: boolean;
}
